export default __webpack_public_path__ + "static/media/40-Fosun.fe8412c9.jpg";